import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { logout } from '../../../../store/userSlice';

const Header = ({ activeMenu, toggleSidebar, isMobile, onLogout }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Get user data from Redux
  const user = useSelector((state) => state.user.user);
  const userName = user?.user_name || 'User';
  const userInitial = userName?.charAt(0).toUpperCase() || 'U';

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    // Clear only auth tokens from cookies
    Cookies.remove('_at');
    Cookies.remove('_rt');

    // Clear Redux state
    dispatch(logout());

    // Close dropdown
    setIsDropdownOpen(false);

    // Call parent logout function if provided
    if (onLogout) {
      onLogout();
    }

    // Navigate to login page
    navigate('/', { replace: true });
  };

  const handleProfileClick = () => {
    navigate('/StudZone/profile');
    setIsDropdownOpen(false);
  };

  return (
    <header className="shadow-sm z-10 bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] px-6 py-4 text-white">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {isMobile && (
            <button
              onClick={toggleSidebar}
              className="text-white mr-4 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          )}
          <h1 className="text-xl font-semibold text-white">{activeMenu}</h1>
        </div>
        <div className="flex items-center space-x-4">
          <div className="relative" ref={dropdownRef}>
            <button
              className="relative flex items-center focus:outline-none group"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <div className="h-8 w-8 rounded-full bg-[#2f4447] flex items-center justify-center text-white font-semibold">
                {userInitial}
              </div>

              {/* Left Tooltip */}
              {!isDropdownOpen && (
                <div className="absolute right-12 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
                  <div className="relative bg-gray-900 text-white text-sm px-3 py-2 rounded-md whitespace-nowrap shadow-lg">
                    {userName}
                    <div className="absolute top-1/2 -right-1 w-2 h-2 bg-gray-900 rotate-45 -translate-y-1/2"></div>
                  </div>
                </div>
              )}
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                <button
                  onClick={handleProfileClick}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Profile Settings
                </button>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;